import { useEffect, useMemo, useState } from "react";
import "./ContactFormGlass.css";

export default function ContactFormGlass({
  id = "contact",
  eyebrow = "CONTACT",
  titleLine1 = "Get in touch",
  titleLine2 = "We would love to hear from you",
  fields = {},
  roleOptions = [],
  submitLabel = "Submit",
  onSubmit = null,
  className = "",
  style = {},
}) {
  const firstRole = useMemo(() => roleOptions?.[0]?.value || "", [roleOptions]);
  const [values, setValues] = useState({
    name: "",
    email: "",
    role: firstRole,
    message: "",
  });

  useEffect(() => {
    setValues(prev => ({ ...prev, role: firstRole }));
  }, [firstRole]);

  function handleChange(e) {
    const { name, value } = e.target;
    setValues(prev => ({ ...prev, [name]: value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit?.(values);
  }

  const {
    nameLabel = "Name",
    namePlaceholder = "Name",
    roleLabel = "Role",
    rolePlaceholder = "",
    emailLabel = "Email",
    emailPlaceholder = "Email",
    messageLabel = "Message",
    messageHelper = "",
    messagePlaceholder = "Type here",
  } = fields || {};

  return (
    <section id={id} className={`contact-glass-section ${className}`.trim()} style={style}>
      <div className="contact-glass-wrap">
        <header className="contact-glass-head">
          <p className="contact-eyebrow">{eyebrow}</p>
          <h2 className="contact-title">
            {titleLine1}<br />{titleLine2}
          </h2>
        </header>

        <div className="contact-card">
          <span className="contact-dot contact-dot--tl" aria-hidden="true" />
          <span className="contact-dot contact-dot--tr" aria-hidden="true" />
          <span className="contact-dot contact-dot--bl" aria-hidden="true" />
          <span className="contact-dot contact-dot--br" aria-hidden="true" />
          <span className="contact-dot contact-dot--mid" aria-hidden="true" />

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="contact-row contact-row--two">
              <label className="contact-field">
                <span className="contact-label">{nameLabel}</span>
                <input
                  type="text"
                  name="name"
                  placeholder={namePlaceholder}
                  value={values.name}
                  onChange={handleChange}
                  required
                />
              </label>

              <label className="contact-field">
                <span className="contact-label">{roleLabel}</span>
                <div className="contact-select-wrap">
                  <select
                    name="role"
                    value={values.role}
                    onChange={handleChange}
                  >
                    {!firstRole && (
                      <option value="">{rolePlaceholder}</option>
                    )}
                    {roleOptions?.map(opt => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>
              </label>
            </div>

            <label className="contact-field">
              <span className="contact-label">{emailLabel}</span>
              <input
                type="email"
                name="email"
                placeholder={emailPlaceholder}
                value={values.email}
                onChange={handleChange}
                required
              />
            </label>

            <label className="contact-field">
              <span className="contact-label">
                {messageLabel}
                {messageHelper && <small>{messageHelper}</small>}
              </span>
              <textarea
                name="message"
                placeholder={messagePlaceholder}
                rows={6}
                value={values.message}
                onChange={handleChange}
                required
              />
            </label>

            <div className="contact-actions">
              <button type="submit" className="contact-submit">
                <span>{submitLabel.toUpperCase()}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
